import { useMemoizedFn } from 'ahooks';
import { history } from 'umi';
import { getConfirmToken } from '@/services/api';
import { API_CODES } from '@/services/constant';
import { useAuthLogin, useLockAsyncFn } from '.';

export const useGenerateConfirmToken = () => {
  const { locateToLogin } = useAuthLogin();

  const { asyncFn, loading } = useLockAsyncFn(getConfirmToken, {
    onSuccess: (res) => {
      history.push(`/order?orderToken=${res?.data?.token}`);
    },
    onFail: (_, res) => {
      if (res?.errorCode === API_CODES.NOT_LOG_IN) {
        locateToLogin();
      }
    },
  });

  return {
    onGenerateConfirmToken: useMemoizedFn(asyncFn),
    loading,
  };
};
